import React from 'react'

function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">Loading Points FYI</h2>
        <p className="text-gray-500">Preparing your loyalty program experience...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner
